import { LoadingStatusType } from "@/enums/enums";
import { SettingTaxInvoiceModel, SettingTransactionRemarkModel } from "@/model/setting";
import service from "@/service/index";
import {
  ConvertToSettingTaxInvoice,
  ConvertToSettingTransactionRemark,
  GetSettingTransactionDueDate,
} from "@/service/setting/settingFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Setting extends VuexModule {
  public settingTransactionDueDate: any = null;
  public settingTransactionDueDateLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public settingTaxInvoice: SettingTaxInvoiceModel | null = null;
  public settingTaxInvoiceLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public settingTransactionRemarkLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public settingTransactionRemark: Array<SettingTransactionRemarkModel> | null = null;

  get getSettingTransactionDueDate(): any {
    return this.settingTransactionDueDate;
  }

  get getSettingTransactionDueDateLoadingStatus(): LoadingStatusType {
    return this.settingTransactionDueDateLoadingStatus;
  }

  get getSettingTaxInvoice(): SettingTaxInvoiceModel | null {
    return this.settingTaxInvoice;
  }

  get getSettingTaxInvoiceLoadingStatus(): LoadingStatusType {
    return this.settingTaxInvoiceLoadingStatus;
  }

  get getSettingTransactionRemarkLoadingStatus(): LoadingStatusType {
    return this.settingTransactionRemarkLoadingStatus;
  }

  get getSettingTransactionRemark(): Array<SettingTransactionRemarkModel> | null {
    return this.settingTransactionRemark;
  }

  @Mutation
  public MutationSettingTransactionDueDate(_settingTransactionDueDate: any) {
    this.settingTransactionDueDate = _settingTransactionDueDate;
  }

  @Mutation
  public MutationSettingTransactionDueDateLoadingStatus(status: LoadingStatusType) {
    this.settingTransactionDueDateLoadingStatus = status;
  }

  @Mutation
  public MutationSettingTaxInvoice(_settingTaxInvoice: SettingTaxInvoiceModel | null) {
    this.settingTaxInvoice = _settingTaxInvoice;
  }

  @Mutation
  public MutationSettingTaxInvoiceLoadingStatus(status: LoadingStatusType) {
    this.settingTaxInvoiceLoadingStatus = status;
  }

  @Mutation
  public MutationSettingTransactionRemarkLoadingStatus(status: LoadingStatusType) {
    this.settingTransactionRemarkLoadingStatus = status;
  }

  @Mutation
  public MutationSettingTransactionRemark(settingTransactionRemark: Array<SettingTransactionRemarkModel>) {
    this.settingTransactionRemark = settingTransactionRemark;
  }

  @Action
  public DoGetSettingTransactionDueDate() {
    if (this.settingTransactionDueDateLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSettingTransactionDueDateLoadingStatus", LoadingStatusType.Loading);
      service.SettingService.DoGetSettingTransactionDueDate()
        .then((res) => {
          const settingTransactionDueDate = GetSettingTransactionDueDate(res.data.settingTransactionDueDate);
          this.context.commit("MutationSettingTransactionDueDate", settingTransactionDueDate);
          this.context.commit("MutationSettingTransactionDueDateLoadingStatus", LoadingStatusType.Success);
        })
        .catch((error) => error);
    }
  }

  @Action
  public DoGetMerchantSettingTaxInvoice() {
    if (this.settingTaxInvoiceLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSettingTaxInvoiceLoadingStatus", LoadingStatusType.Loading);
      service.SettingService.DoGetMerchantSettingTaxInvoice()
        .then((res) => {
          const settingTaxInvoice = ConvertToSettingTaxInvoice(res.data.settingTaxInvoice);
          this.context.commit("MutationSettingTaxInvoice", settingTaxInvoice);
          this.context.commit("MutationSettingTaxInvoiceLoadingStatus", LoadingStatusType.Success);
        })
        .catch((error) => error);
    }
  }

  @Action
  public DoGetSettingTransactionRemark() {
    return new Promise((resolve) => {
      if (this.settingTransactionRemarkLoadingStatus !== LoadingStatusType.Loading) {
        this.context.commit("MutationSettingTransactionRemarkLoadingStatus", LoadingStatusType.Loading);
        const isUseMainDatabase = this.settingTransactionRemark != null;
        service.SettingService.DoGetSettingTransactionRemark(isUseMainDatabase)
          .then((res) => {
            const settingTransactionRemark = ConvertToSettingTransactionRemark(res.data.settingTransactionRemark);
            this.context.commit("MutationSettingTransactionRemark", settingTransactionRemark);
            this.context.commit("MutationSettingTransactionRemarkLoadingStatus", LoadingStatusType.Success);
          })
          .finally(() => {
            resolve("resolved");
          })
          .catch((error) => error);
      }
    });
  }
}
